// ============================================================
// FILE: assets/theme-jquery-pages.js
// Include karo theme.liquid mein CONDITIONAL block mein:
//
// {% if template.name == 'page' 
//      and page.handle != 'orders-and-returns' 
//      and page.handle != 'tracking' %}
//   <script src="{{ 'theme-jquery-pages.js' | asset_url }}" defer="defer"></script>
// {% endif %}
//
// NOTE: Ye file SIRF page templates par load hogi
// (orders-and-returns aur tracking pages ko chhod ke)
// ============================================================

$(document).ready(function () {

  // -----------------------------------------------------------
  // 4. ABOUT PAGE — EQUAL HEIGHT (image = content height)
  // Was: theme.liquid (conditional page template block)
  // Condition: page template, except orders/tracking pages
  // -----------------------------------------------------------
  function setEqualHeight() {
    if ($(window).width() >= 1024) {
      var contentHeight = $(".about-content").outerHeight();
      $(".about-images img").css("height", contentHeight + "px");
    } else {
      $(".about-images img").css("height", "auto");
    }
  }

  // Run on page load
  setEqualHeight();

  // Run on window resize
  $(window).on("resize", function () {
    setEqualHeight();
  });

});
